import { Subcategory } from "./subcategory";

export class Category {

    categoryID: number;
    categoryName: string;
    subCategories: Subcategory[]; 
    
}